// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   IconButton,
// } from "@mui/material";
// import { Edit, Delete } from "@mui/icons-material";
// import TableComponent from "../../Components/TableComponent/TableComponent";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import { LoadingSpinner } from "../../Components/spinner/spinner";
// import { API_BASE_URL } from "../../config";
// import api from "../../api/axiosInterceptor";
// import axios from "axios";

// export const AdminNotificationComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Snackbar state
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");

//   // Dialog state
//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedNotification, setSelectedNotification] = useState(null);

//   // Form state
//   const [formData, setFormData] = useState({
//     subject: "",
//     link: "",
//   });

//   const [formErrors, setFormErrors] = useState({});

//   // Delete confirmation dialog state
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteNotification, setDeleteNotification] = useState(null);

//   const columns = [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     { id: "subject", field: "subject", headerName: "Subject", width: 400 },
//     {
//       id: "link",
//       field: "link",
//       headerName: "View Details",
//       width: 120,
//       renderCell: (params) => (
//         <a href={params.value} target="_blank" rel="noopener noreferrer">
//           View Details
//         </a>
//       ),
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton
//             aria-label="edit"
//             color="primary"
//             onClick={() => handleEdit(params.row)}
//           >
//             <Edit />
//           </IconButton>
//           <IconButton
//             aria-label="delete"
//             color="error"
//             onClick={() => handleDeleteConfirmation(params.row)}
//           >
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchNotifications();
//   }, []);

//   const fetchNotifications = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/social-news/`)
//       .then((response) => {
//         const data = response.data;
//         // If response is single object, wrap into array for table
//         const notificationArray = Array.isArray(data)
//           ? data
//           : data
//           ? [data]
//           : [];
//         const apiData = notificationArray.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           subject: item.subject,
//           link: item.link,
//         }));
//         setRows(apiData);
//       })
//       .catch(() => {
//         setSnackbarMessage("Failed to load notifications.");
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       })
//       .finally(() => setLoading(false));
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAdd = () => {
//     setIsEditMode(false);
//     setFormData({ subject: "", link: "" });
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (notification) => {
//     setIsEditMode(true);
//     setSelectedNotification(notification);
//     setFormData({ subject: notification.subject, link: notification.link });
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (notification) => {
//     setDeleteNotification(notification);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(
//         `${API_BASE_URL}/home-notification/social-news/${deleteNotification.id}/`
//       )
//       .then(() => {
//         setSnackbarMessage("Notification deleted successfully.");
//         setSnackbarSeverity("success");
//         setSnackbarOpen(true);
//         fetchNotifications();
//       })
//       .catch(() => {
//         setSnackbarMessage("Failed to delete notification.");
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteNotification(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.subject?.trim()) errors.subject = "Subject is required";
//     if (!formData.link?.trim()) errors.link = "Link is required";
//     else if (!/^https?:\/\/.+\..+/.test(formData.link))
//       errors.link = "Invalid link format";
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFormSubmit = () => {
//     if (!validateForm()) return;

//     if (isEditMode) {
//       api
//         .patch(
//           `${API_BASE_URL}/home-notification/social-news/${selectedNotification.id}/`,
//           formData
//         )
//         .then(() => {
//           setSnackbarMessage("Notification updated successfully.");
//           setSnackbarSeverity("success");
//           setSnackbarOpen(true);
//           fetchNotifications();
//           setOpenFormDialog(false);
//         })
//         .catch(() => {
//           setSnackbarMessage("Failed to update notification.");
//           setSnackbarSeverity("error");
//           setSnackbarOpen(true);
//         });
//     } else {
//       api
//         .post(`${API_BASE_URL}/home-notification/social-news/`, formData)
//         .then(() => {
//           setSnackbarMessage("Notification added successfully.");
//           setSnackbarSeverity("success");
//           setSnackbarOpen(true);
//           fetchNotifications();
//           setOpenFormDialog(false);
//         })
//         .catch(() => {
//           setSnackbarMessage("Failed to add notification.");
//           setSnackbarSeverity("error");
//           setSnackbarOpen(true);
//         });
//     }
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         bgcolor="rgba(195,234,203,0.1)"
//         p={2}
//       >
//         <Typography variant="h4" component="h1" sx={{ fontWeight: "bold" }}>
//           Notifications
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAdd}>
//           Add Notification
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: "#1976d2",
//             color: "#fff",
//             fontWeight: "bold",
//           },
//         }}
//       />

//       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? "Edit Notification" : "Add Notification"}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Subject"
//             fullWidth
//             value={formData.subject}
//             error={!!formErrors.subject}
//             helperText={formErrors.subject}
//             onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
//           />
//           <TextField
//             margin="dense"
//             label="Link"
//             fullWidth
//             value={formData.link}
//             error={!!formErrors.link}
//             helperText={formErrors.link}
//             onChange={(e) => setFormData({ ...formData, link: e.target.value })}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenFormDialog(false)}>Cancel</Button>
//           <Button variant="contained" color="primary" onClick={handleFormSubmit}>
//             {isEditMode ? "Update" : "Add"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           Are you sure you want to delete this notification?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
//           <Button variant="contained" color="error" onClick={handleDelete}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import TableComponent from "../../Components/TableComponent/TableComponent";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import { LoadingSpinner } from "../../Components/spinner/spinner";
import { API_BASE_URL } from "../../config";
import api from "../../api/axiosInterceptor";
import axios from "axios";

export const AdminNotificationComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  // Dialog state
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);

  // Form state - Added language field
  const [formData, setFormData] = useState({
    subject: "",
    link: "",
    langage: "", // Matches your Django model field name
  });

  const [formErrors, setFormErrors] = useState({});

  // Delete confirmation dialog state
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteNotification, setDeleteNotification] = useState(null);

  // Language options
  const languageOptions = [
    { value: "en", label: "English" },
    { value: "kn", label: "Kannada" },
  ];

  const columns = [
    { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
    { id: "subject", field: "subject", headerName: "Subject", width: 350 },
    { 
      id: "langage", 
      field: "langage", 
      headerName: "Language", 
      width: 120,
      renderCell: (params) => (
        <Typography variant="body2">
          {params.value === "en" ? "English" : params.value === "kn" ? "Kannada" : params.value || "N/A"}
        </Typography>
      ),
    },
    {
      id: "link",
      field: "link",
      headerName: "View Details",
      width: 120,
      renderCell: (params) => (
        <a href={params.value} target="_blank" rel="noopener noreferrer">
          View Details
        </a>
      ),
    },
    {
      id: "actions",
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton
            aria-label="edit"
            color="primary"
            onClick={() => handleEdit(params.row)}
          >
            <Edit />
          </IconButton>
          <IconButton
            aria-label="delete"
            color="error"
            onClick={() => handleDeleteConfirmation(params.row)}
          >
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = () => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/home-notification/social-news/`)
      .then((response) => {
        const data = response.data;
        // If response is single object, wrap into array for table
        const notificationArray = Array.isArray(data)
          ? data
          : data
          ? [data]
          : [];
        const apiData = notificationArray.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          subject: item.subject,
          link: item.link,
          langage: item.langage, // Added language field
        }));
        setRows(apiData);
      })
      .catch(() => {
        setSnackbarMessage("Failed to load notifications.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      })
      .finally(() => setLoading(false));
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAdd = () => {
    setIsEditMode(false);
    setFormData({ subject: "", link: "", langage: "" });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (notification) => {
    setIsEditMode(true);
    setSelectedNotification(notification);
    setFormData({ 
      subject: notification.subject, 
      link: notification.link, 
      langage: notification.langage || "" 
    });
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (notification) => {
    setDeleteNotification(notification);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api
      .delete(
        `/home-notification/social-news/${deleteNotification.id}/`
      )
      .then(() => {
        setSnackbarMessage("Notification deleted successfully.");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        fetchNotifications();
      })
      .catch(() => {
        setSnackbarMessage("Failed to delete notification.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteNotification(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.subject?.trim()) errors.subject = "Subject is required";
    if (!formData.link?.trim()) errors.link = "Link is required";
    else if (!/^https?:\/\/.+\..+/.test(formData.link))
      errors.link = "Invalid link format";
    if (!formData.langage) errors.langage = "Language is required";
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFormSubmit = () => {
    if (!validateForm()) return;

    if (isEditMode) {
      api
        .patch(
          `/home-notification/social-news/${selectedNotification.id}/`,
          formData
        )
        .then(() => {
          setSnackbarMessage("Notification updated successfully.");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          fetchNotifications();
          setOpenFormDialog(false);
        })
        .catch(() => {
          setSnackbarMessage("Failed to update notification.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        });
    } else {
      api
        .post(`/home-notification/social-news/`, formData)
        .then(() => {
          setSnackbarMessage("Notification added successfully.");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          fetchNotifications();
          setOpenFormDialog(false);
        })
        .catch(() => {
          setSnackbarMessage("Failed to add notification.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        });
    }
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: "100%",
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        bgcolor="rgba(195,234,203,0.1)"
        p={2}
      >
        <Typography variant="h4" component="h1" sx={{ fontWeight: "bold" }}>
          Notifications
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAdd}>
          Add Notification
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#1976d2",
            color: "#fff",
            fontWeight: "bold",
          },
        }}
      />

      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? "Edit Notification" : "Add Notification"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Subject"
            fullWidth
            value={formData.subject}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Link"
            fullWidth
            value={formData.link}
            error={!!formErrors.link}
            helperText={formErrors.link}
            onChange={(e) => setFormData({ ...formData, link: e.target.value })}
          />
          {/* Language Dropdown */}
          <FormControl fullWidth margin="dense" error={!!formErrors.langage}>
            <InputLabel>Language</InputLabel>
            <Select
              value={formData.langage}
              label="Language"
              onChange={(e) => setFormData({ ...formData, langage: e.target.value })}
            >
              {languageOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleFormSubmit}>
            {isEditMode ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this notification?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
